import { useLocation } from 'react-router'
import { useAuth0 } from '@auth0/auth0-react'
import { Stack } from '@mui/material'

const REDIRECT_PREFIX = '/login/redirect/'

const Login = (): JSX.Element => {
  const { loginWithRedirect } = useAuth0()
  const { pathname } = useLocation()

  // read the return url from the raw (still-encoded) path and decode it exactly once. useParams can't be used here
  // because react-router decodes route params more than once, which corrupts values like %25 in the query string
  const encodedRedirect = pathname.startsWith(REDIRECT_PREFIX) ? pathname.slice(REDIRECT_PREFIX.length) : ''
  let redirectUrl = '/'
  try {
    redirectUrl = encodedRedirect ? decodeURIComponent(encodedRedirect) : '/'
  } catch {
    // malformed encoding so fall back to the home page
  }

  loginWithRedirect({
    authorizationParams: {
      scope: 'profile email read:current_user',
    },
    appState: { redirectUrl },
  })

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100%' }}>
      Redirecting to login...
    </Stack>
  )
}

export default Login
